import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useGenerateCustomsQueryTestFile = () => {
  return useMutation({
    // eslint-disable-next-line max-statements
    mutationFn: async () => {
      const response = await apiClient.declarant.generateCustomsQueryTestFile.mutation({ body: {} });
      if (response.status !== 200) throw response.body;

      const { base64, fileName } = response.body.data;

      const blob = new Blob([Uint8Array.from(atob(base64), (c) => c.charCodeAt(0))], { type: 'application/xml' });
      const href = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onSuccess: () => {
      toast.success('File generation initiated!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the file!');
    },
  });
};
